import { patientTopCard } from '@shared/helpers/pdf-patient-card.helper';
import { Derivation, Interconsultation } from '@shared/interfaces/derivation.interface';
import { REHABILITATION_SPECIALTIES } from '@clinical/derivations/constants/specialties.const';

export function buildContentPdfDerivation(
  paperwork: any,
  group: { rows: Derivation[] }
) {
  const { rows } = group;

  function buildRow(item: Derivation): any[] {
    // Encabezado y datos comunes por fila
    const isIntegralHealt = paperwork.content[0]?.integralHealth; // 'OK' | 'NOOK'
    const content: any[] = [];

    // (1) Título según grupo de interconsulta
    const interGroup = item.interconsultation[0]?.group;
    let title = '';
    if (
      item.interconsultation.length &&
      (interGroup === 'Fonoaudiología' ||
       interGroup === 'Kinesiología' ||
       interGroup === 'Terapia Ocupacional')
    ) {
      title = interGroup.toUpperCase();
    }

    // (2) Campos base
    const reason =
      item.reason === ' '
        ? item.interconsultation[item.interconsultation.length - 1]?.observations
        : item.reason;

    const specialty = (item.service.derivation?.specialty + ' ' + item.service.derivation?.service).trim();
    const contactCaution = item.contactCaution === true ? 'Sí' : 'No';

    const especialidad = item?.interconsultation[0]?.name ? item.interconsultation[0].name : '';

    // (3) Branch de especialidades de Rehabilitación
    if (REHABILITATION_SPECIALTIES.includes(specialty.toLocaleLowerCase())) {
      const diagnostics = item.diagnostics;
      const indications = item.interconsultation;

      const TITTLE = [
        { text: `${title}`, bold: true, alignment: 'center' },
        {
          marginTop: 10,
          alignment: 'left',
          stack: [
            { fontSize: 12, text: `INFORMACIÓN DE LA SOLICITUD`, bold: true },
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }] },
          ],
        },
      ];

      const CONTACT_CAUTION = [
        {
          columns: [
            {
              columns: [
                {
                  stack: [
                    { fontSize: 12, text: `Precaución de Contacto:`, bold: true },
                  ],
                  width: '20%',
                },
                {
                  text: [{ fontSize: 12, text: `${contactCaution}` }],
                  width: '80%',
                },
              ],
              margin: [0, 5, 0, 0],
            },
          ],
          margin: [0, 5, 0, 0],
        },
      ];

      const DIAGNOSTICS = diagnostics
        ? [
            {
              columns: [
                {
                  columns: [
                    {
                      stack: [{ fontSize: 12, text: `Diagnósticos:`, bold: true }],
                      width: '20%',
                    },
                    {
                      text: [{ fontSize: 12, text: `${diagnostics.join(', ')}` }],
                      width: '80%',
                    },
                  ],
                  margin: [0, 5, 0, 0],
                },
              ],
              margin: [0, 5, 0, 0],
            },
          ]
        : [];

      const INDICATIONS = (indications ?? []).map((ind: Interconsultation) => {
        const indicationName = ind.name.toUpperCase();
        return [
          {
            columns: [
              {
                columns: [
                  {
                    stack: [
                      { fontSize: 12, text: `${indicationName}`, bold: true },
                      {
                        text: [
                          { fontSize: 12, text: 'Nº de sesiones: ' },
                          {
                            fontSize: 12,
                            text: ind.totalSessions ? ind.totalSessions : ind.totalControls,
                            bold: true,
                          },
                        ],
                        italics: true,
                      },
                      {
                        text: [
                          { fontSize: 12, text: 'Observación: ' },
                          { fontSize: 12, text: ind.observations, bold: true },
                        ],
                        width: '60%',
                      },
                    ],
                    width: '100%',
                  },
                ],
                margin: [0, 5, 0, 0],
              },
            ],
            margin: [0, 5, 0, 0],
          },
        ];
      });

      const note3 = [
        {
          marginTop: 30,
          fontSize: 8,
          alignment: 'left',
          text:
            'Esta derivación es válida por un año desde la fecha de emisión \n' +
            'y cubre únicamente los controles indicados con la especialidad \n' +
            'señalada (siempre que se encuentre cubierta por su póliza \n' +
            'o convenio y haya seguido el flujo de atención). \n' +
            'Si requiere de más controles, puede agendar una atención con \n' +
            'su médico de cabecera o escribir por WhatsApp al equipo clínico.\n',
        },
      ];

      content.push(
        TITTLE,
        DIAGNOSTICS,
        CONTACT_CAUTION,
        INDICATIONS,
        isIntegralHealt === 'OK' ? note3 : []
      );

    // (4) “Otra Especialidad” / “Seguimiento …”
    } else if (
      specialty.toLowerCase() === 'otra especialidad' ||
      specialty.toLowerCase() === 'seguimiento orientacion quirurgica'
    ) {
      
      const TITTLE = [
        {
          marginTop: 10,
          alignment: 'left',
          stack: [
            { fontSize: 12, text: `INFORMACIÓN DE LA SOLICITUD`, bold: true },
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }] },
          ],
        },
      ];

      const CONTENT_OTHER = [
        {
          columns: [
            {
              columns: [
                {
                  stack: [
                    {
                      text: [
                        { marginTop: 10, fontSize: 12, text: 'Se deriva a: ' },
                        { fontSize: 12, text: specialty, bold: true },
                      ],
                      italics: true,
                    },
                    {
                      text: [
                        { fontSize: 12, text: 'Especialidad: ' },
                        { fontSize: 12, text: `${item.service.other}`, bold: true },
                      ],
                      italics: true,
                    },
                    {
                      text: [
                        { fontSize: 12, text: 'Motivo de consulta: ' },
                        {
                          fontSize: 12,
                          text: reason || item.interconsultation[0]?.observations,
                          bold: true,
                        },
                      ],
                      width: '60%',
                    },
                  ],
                  width: '100%',
                },
              ],
              margin: [0, 5, 0, 0],
            },
          ],
          margin: [0, 5, 0, 0],
        },
      ];

      content.push(TITTLE, CONTENT_OTHER);

    // (5) Caso general
    } else {
      const TITTLE = [
        {
          marginTop: 10,
          alignment: 'left',
          stack: [
            { fontSize: 12, text: `INFORMACIÓN DE LA SOLICITUD`, bold: true },
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }] },
          ],
        },
      ];

      const CONTENT_OTHER = [
        {
          columns: [
            {
              columns: [
                {
                  stack: [
                    {
                      text: [
                        { marginTop: 10, fontSize: 12, text: 'Se deriva a: ' },
                        {
                          fontSize: 12,
                          text: specialty !== especialidad ? `${specialty}` : specialty,
                          bold: true,
                        },
                      ],
                      italics: true,
                    },
                    {
                      text: [
                        {
                          fontSize: 12,
                          text: item.interconsultation[0]?.totalControls ? 'Nº de controles: ' : '',
                        },
                        {
                          fontSize: 12,
                          text: item.interconsultation[0]?.totalControls
                            ? item.interconsultation[0].totalControls
                            : '',
                          bold: true,
                        },
                      ],
                      italics: true,
                    },
                    {
                      text: [
                        { fontSize: 12, text: 'Motivo de consulta: ' },
                        {
                          fontSize: 12,
                          text: reason || item.interconsultation[0]?.observations,
                          bold: true,
                        },
                      ],
                      width: '100%',
                    },
                  ],
                },
              ],
              margin: [0, 5, 0, 0],
            },
          ],
          margin: [0, 5, 0, 0],
        },
      ];

      let note1: any[] = [];
      if (
        specialty.toLowerCase() === 'programa de insuficiencia cardiaca uc' ||
        specialty.toLowerCase() === 'programa de insuficiencia cardiaca'
      ) {
        note1 = [
          {
            marginTop: 100,
            fontSize: 8,
            alignment: 'left',
            text:
              'Programa de Insuficiencia Cardiaca UC\n' +
              'Contacto:  Valezka Jimenez Enfermera de Cardiología y Programa de Insuficiencia cardiaca UC\n' +
              'Correo: insuficienciacardiaca@ucchristus.cl \n' +
              'WhatsApp +569 34276462',
          },
        ];
      }
      
      let note2: any[] = [];
      if (specialty.trim().toLowerCase() === 'unidad salud mental integral psiquiatria o psicologia') {
        note2 = [
          {
            marginTop: 100,
            fontSize: 8,
            alignment: 'left',
            text:
              'Unidad de Salud Mental Integral - Psiquiatria o Psicologia\n' +
              'Centro Médico Providencia\n' +
              'Teléfono de Contacto: 224820056\n' +
              'Correo de Contacto:  contacto.providencia@ucchristus.cl\n',
          },
          {
            fontSize: 8,
            alignment: 'left',
            decoration: 'underline',
            text: 'Más información en Unidad Salud Mental Integral y Recepción',
            link: 'https://www.ucchristus.cl/especialidades-y-servicios/unidades/unidad-salud-mental-integral-y-recepcion',
          },
        ];
      }

      const note3 = [
        {
          marginTop: 30,
          fontSize: 8,
          alignment: 'left',
          text:
            'Esta derivación es válida por un año desde la fecha de emisión \n' +
            'y cubre únicamente los controles indicados con la especialidad \n' +
            'señalada (siempre que se encuentre cubierta por su póliza \n' +
            'o convenio y haya seguido el flujo de atención). \n' +
            'Si requiere de más controles, puede agendar una atención con \n' +
            'su médico de cabecera o escribir por WhatsApp al equipo clínico.\n',
        },
      ];

      content.push(TITTLE, CONTENT_OTHER, note1, note2, isIntegralHealt === 'OK' ? note3 : []);
    }

    // Devolvemos el bloque completo por fila (cabecera + contenido)
    return [...patientTopCard(paperwork), ...content];
  }

  // Armamos todo el contenido y lo aplanamos (array de arrays -> array)
  return rows.map(buildRow).flat();
}
